import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../components/Home.vue";
// import Publisher from "../components/Publisher.vue";
// import Advertisers from "../components/Advertisers.vue";
import SearchArbitrage from "../components/SearchArbitrage.vue";
import LeadGen from "../components/LeadGen.vue";
import AboutUs from "../components/AboutUs.vue";
import OurBusiness from "../components/OurBusiness.vue";
import ContactUsDetail from "../components/ContactUsDetail.vue";
import TermsAndPolicies from "../components/legal/TermsAndPolicies.vue";
import PrivacyPolicy from "../components/legal/PrivacyPolicy.vue";
import LegalInformation from "../components/legal/LegalInformation.vue";
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  // {
  //   path: "/publisher",
  //   name: "Publisher",
  //   component: Publisher,
  // },
  // {
  //   path: "/advertisers",
  //   name: "Advertisers",
  //   component: Advertisers,
  // },
  {
    path: "/search-arbitrage",
    name: "SearchArbitrage",
    component: SearchArbitrage,
  },
  {
    path: "/leadgen",
    name: "LeadGen",
    component: LeadGen,
  },

  {
    path: "/aboutus",
    name: "AboutUs",
    component: AboutUs,
  },
  {
    path: "/ourbusiness",
    name: "OurBusiness",
    component: OurBusiness,
  },
  {
    path: "/contactusdetail",
    name: "ContactUsDetail",
    component: ContactUsDetail,
  },
  {
    path: "/legal/terms-and-policies",
    name: "TermsAndPolicies",
    component: TermsAndPolicies,
    meta: { title: "Terms and Policies" },
  },
  {
    path: "/legal/privacy-policy",
    name: "PrivacyPolicy",
    component: PrivacyPolicy,
    meta: { title: "Privacy Policy" },
  },
  {
    path: "/legal/legal-information",
    name: "LegalInformation",
    component: LegalInformation,
    meta: { title: "Legal Information" },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;
